import { Funder } from "./FunderTypes";

export enum GeneratedNameOrigin {
  ADVANCED_SEARCH,
  SMARTLIST,
}

export interface GenerateSmartlistNameDTO {
  origin: GeneratedNameOrigin;
  context: Object;
  funderEntitiesUuids: Funder[];
}
